module.exports = __webpack_public_path__ + "img/行政法.5d4f9d2b.png";